let groups = [
    {
        id: 0,
        name: 'General',
        image: 1,
    },  
    {
      id: 1,
      name: 'Swimming club',
      image: 2,
    },
    {
      id: 2,
      name: 'Mountain Biking',
      image: 3,
    },

]

export default groups;